import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { externalLoanCardSx, externalLoanNestedCardSx } from './externalLoanCardStyles';

const RepaymentTabPanel = ({ repayment }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      ...externalLoanCardSx,
    }}
  >
    <Stack spacing={2}>
      <Typography variant="h6" fontWeight={700}>Repayment workspace</Typography>
      <Box sx={{ p: 2, ...externalLoanNestedCardSx }}>
        <Stack spacing={1}>
          <Typography variant="subtitle2" color="text.secondary">Outstanding balance</Typography>
          <Typography variant="h5" fontWeight={800}>TZS {new Intl.NumberFormat('en-TZ').format(repayment.outstandingAmount)}</Typography>
          <Typography variant="subtitle2" color="text.secondary">Next due date</Typography>
          <Typography>{repayment.nextDueDate}</Typography>
          <Typography variant="subtitle2" color="text.secondary">Progress</Typography>
          <Chip label={`${repayment.progressPercentage}% complete`} color="primary" size="small" />
        </Stack>
      </Box>
    </Stack>
  </Paper>
);

export default RepaymentTabPanel;
